const data = [
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-59.57, -80.0],
          [-60.1, -81],
          [-64.48, -80.92],
          [-66.2, -80.25],
          [-61.88, -80.39],
          [-60.6, -79.62],
          [-59.57, -80.0],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-159.20, -79.49],
          [-162.4, -79.28],
          [-163.10, -78.22],
          [-159.20, -79.49],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-45.15, -78.04],
          [-43.33, -80.02],
          [-52.85, -80.96],
          [-53.98, -80.22],
          [-48.66, -78.04],
          [-45.15, -78.04],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-121.21, -73.50],
          [-118.72, -73.48],
          [-120.23, -74.08],
          [-122.62, -73.65],
          [-121.21, -73.50],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-125.5, -73.48],
          [-124.03, -73.87],
          [-127.28, -73.46],
          [-125.5, -73.48],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-98.98, -71.93],
          [-96.78, -71.95],
          [-96.2, -72.52],
          [-100.78, -72.50],
          [-102.33, -71.89],
          [-98.98, -71.93],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-68.45, -70.95],
          [-68.78, -72.17],
          [-74.95, -72.07],
          [-73.91, -71.26],
          [-72.07, -71.19],
          [-70.25, -68.87],
          [-68.45, -70.95],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-58.61, -64.15],
          [-62.02, -64.79],
          [-62.1, -66.1],
          [-65.50, -67.58],
          [-61.80, -70.71],
          [-60.82, -73.69],
          [-70.60, -76.63],
          [-77.2, -76.71],
          [-73.65, -77.90],
          [-77.92, -78.37],
          [-78.02, -79.18],
          [-63.25, -81.74],
          [-58.22, -83.21],
          [-49.76, -81.72],
          [-42.80, -82.08],
          [-40.77, -81.35],
          [-28.5, -80.33],
          [-29.68, -79.2],
          [-35.6, -79.45],
          [-35.77, -78.33],
          [-28.88, -76.67],
          [-17.52, -75.12],
          [-16.11, -73.4],
          [-11.0, -71.5],
          [-7.41, -71.69],
          [-6.86, -70.93],
          [-5.53, -71.40],
          [-0.65, -71.22],
          [-0.22, -71.63],
          [7.74, -69.89],
          [10.81, -70.83],
          [13.42, -69.97],
          [15.12, -70.40],
          [18.20, -69.87],
          [21.45, -70.0],
          [22.56, -70.69],
          [27.09, -70.46],
          [31.9, -69.65],
          [33.8, -68.50],
          [38.64, -69.77],
          [41.95, -68.60],
          [53.61, -65.89],
          [56.35, -65.97],
          [61.42, -67.95],
          [64.05, -67.40],
          [68.8, -67.93],
          [69.67, -69.22],
          [67.81, -70.30],
          [69.06, -70.67],
          [67.9, -71.85],
          [69.86, -72.26],
          [73.86, -69.87],
          [77.64, -69.46],
          [79.11, -68.32],
          [82.77, -67.20],
          [86.75, -67.1],
          [87.98, -66.2],
          [89.67, -67.1],
          [99.71, -67.24],
          [102.83, -65.56],
          [106.18, -66.93],
          [113.60, -65.87],
          [119.83, -67.26],
          [123.22, -66.48],
          [134.75, -66.2],
          [135.07, -65.30],
          [136.61, -66.77],
          [145.4, -66.91],
          [148.8, -68.38],
          [154.28, -68.56],
          [171.20, -71.69],
          [164.23, -75.45],
          [163.4, -77.06],
          [166.99, -78.75],
          [160.92, -79.7],
          [159.78, -80.94],
          [180, -84.71],
          [180, -90],
          [-180, -90],
          [-180, -84.71],
          [-179.05, -84.13],
          [-174.38, -84.53],
          [-169.95, -83.88],
          [-148.53, -85.60],
          [-142.89, -84.5],
          [-153.58, -83.68],
          [-152.86, -82.04],
          [-156.83, -81.10],
          [-150.64, -81.33],
          [-146.7, -79.92],
          [-155.32, -79.06],
          [-158.36, -76.88],
          [-151.33, -77.39],
          [-146.10, -76.47],
          [-146.20, -75.3],
          [-135.21, -74.30],
          [-119.70, -74.47],
          [-113.94, -73.71],
          [-112.29, -74.71],
          [-111.26, -74.4],
          [-107.55, -75.18],
          [-100.64, -75.30],
          [-103.68, -72.61],
          [-96.33, -73.61],
          [-90.08, -73.32],
          [-89.22, -72.55],
          [-81.47, -73.85],
          [-80.29, -73.12],
          [-76.22, -73.9],
          [-67.95, -72.79],
          [-68.54, -69.71],
          [-67.25, -66.87],
          [-63.00, -64.64],
          [-57.81, -63.27],
          [-58.61, -64.15],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-67.7, -53.8],
          [-65.0, -54.7],
          [-65.5, -55.2],
          [-66.9, -54.89],
          [-68.14, -55.61],
          [-69.23, -55.49],
          [-74.66, -52.83],
          [-71.10, -54.07],
          [-69.34, -52.51],
          [-67.7, -53.8],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-58.5, -51.1],
          [-58.0, -51.9],
          [-60.7, -52.3],
          [-61.2, -51.8],
          [-58.5, -51.1],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [70.2, -49.7],
          [68.74, -49.77],
          [68.93, -48.62],
          [70.52, -49.06],
          [70.2, -49.7],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [145.39, -40.79],
          [148.28, -40.87],
          [147.91, -43.21],
          [146.04, -43.5],
          [144.71, -41.16],
          [144.74, -40.70],
          [145.39, -40.79],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [173.0, -40.91],
          [174.24, -41.34],
          [172.71, -43.37],
          [173.0, -43.85],
          [171.45, -44.24],
          [170.61, -45.90],
          [169.33, -46.64],
          [166.67, -46.2],
          [168.30, -44.12],
          [170.52, -43.03],
          [172.09, -40.95],
          [172.79, -40.49],
          [173.0, -40.91],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [174.61, -36.15],
          [176.76, -37.88],
          [178.51, -37.69],
          [177.9, -39.16],
          [177.20, -39.14],
          [175.2, -41.68],
          [174.65, -41.28],
          [174.9, -39.90],
          [173.82, -39.50],
          [174.69, -37.38],
          [172.63, -34.52],
          [174.32, -35.26],
          [174.61, -36.15],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [167.1, -22.1],
          [165.47, -21.6],
          [164.0, -20.10],
          [167.1, -22.1],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [178.37, -17.3],
          [178.55, -18.15],
          [177.38, -18.16],
          [177.67, -17.38],
          [178.37, -17.3],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [179.36, -16.80],
          [178.59, -16.63],
          [180, -16.06],
          [180, -16.55],
          [179.36, -16.80],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [167.10, -14.93],
          [167.2, -15.7],
          [166.79, -15.66],
          [166.62, -14.62],
          [167.10, -14.93],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [50.05, -13.55],
          [50.37, -15.70],
          [49.67, -15.7],
          [49.77, -16.87],
          [47.54, -23.78],
          [47.09, -24.94],
          [45.4, -25.60],
          [44.0, -24.98],
          [43.34, -22.77],
          [43.43, -21.33],
          [44.46, -19.43],
          [43.96, -17.4],
          [44.44, -16.21],
          [46.31, -15.7],
          [47.70, -14.59],
          [49.19, -12.04],
          [50.05, -13.55],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.56, -13.76],
          [143.92, -14.54],
          [144.56, -14.17],
          [145.37, -14.98],
          [146.38, -18.95],
          [148.84, -20.39],
          [149.67, -22.34],
          [150.72, -22.40],
          [150.9, -23.46],
          [153.13, -26.07],
          [153.56, -28.1],
          [153.0, -30.92],
          [150.32, -35.67],
          [149.99, -37.42],
          [146.31, -39.03],
          [144.87, -38.41],
          [145.03, -37.89],
          [143.6, -38.80],
          [140.63, -38.01],
          [139.57, -36.13],
          [138.12, -35.61],
          [138.20, -34.38],
          [136.82, -35.26],
          [137.8, -32.9],
          [135.98, -34.8],
          [134.27, -32.61],
          [131.32, -31.49],
          [126.14, -32.21],
          [124.22, -32.95],
          [123.6, -33.8],
          [119.89, -33.97],
          [118.02, -35.06],
          [115.02, -34.19],
          [115.71, -33.2],
          [115.6, -31.61],
          [113.33, -26.11],
          [113.77, -26.54],
          [113.44, -25.62],
          [114.23, -26.29],
          [113.39, -24.38],
          [114.1, -21.75],
          [114.22, -22.51],
          [116.71, -20.70],
          [120.85, -19.68],
          [123.01, -16.40],
          [123.43, -17.26],
          [123.85, -17.06],
          [123.81, -16.11],
          [124.25, -16.32],
          [125.68, -14.23],
          [127.06, -13.81],
          [128.3, -14.86],
          [129.62, -14.9],
          [129.4, -14.42],
          [130.61, -12.53],
          [132.57, -12.11],
          [131.82, -11.27],
          [132.35, -11.12],
          [135.29, -12.24],
          [136.49, -11.85],
          [136.95, -12.35],
          [135.96, -13.32],
          [135.5, -14.99],
          [140.21, -17.71],
          [141.27, -16.38],
          [141.68, -12.40],
          [142.51, -10.66],
          [143.56, -13.76],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [162.11, -10.48],
          [162.39, -10.82],
          [161.7, -10.8],
          [161.3, -10.20],
          [162.11, -10.48],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.71, -10.2],
          [118.96, -9.55],
          [119.9, -9.36],
          [120.71, -10.2],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [160.85, -9.87],
          [159.84, -9.79],
          [159.70, -9.24],
          [160.85, -9.87],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [124.43, -10.1],
          [123.4, -10.2],
          [125.08, -8.65],
          [127.33, -8.39],
          [124.43, -10.1],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[117.9, -8.09], [119.12, -8.70], [116.7, -9.03], [117.9, -8.09]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [122.90, -8.09],
          [122.75, -8.6],
          [119.92, -8.8],
          [120.71, -8.23],
          [122.90, -8.09],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [108.62, -6.77],
          [110.53, -6.87],
          [110.7, -6.46],
          [115.70, -8.37],
          [114.56, -8.75],
          [111.52, -8.30],
          [105.36, -6.85],
          [106.05, -5.89],
          [108.62, -6.77],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [134.72, -6.21],
          [134.2, -6.89],
          [134.5, -5.44],
          [134.72, -6.21],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [155.8, -6.8],
          [155.16, -6.53],
          [154.51, -5.13],
          [155.8, -6.8],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [151.98, -5.47],
          [150.24, -6.31],
          [148.31, -5.74],
          [149.84, -5.50],
          [150.1, -5.00],
          [150.23, -5.53],
          [150.80, -5.45],
          [151.64, -4.75],
          [151.53, -4.16],
          [152.33, -4.31],
          [151.98, -5.47],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [127.24, -3.45],
          [126.87, -3.79],
          [125.98, -3.17],
          [127.24, -3.45],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [130.47, -3.09],
          [130.83, -3.85],
          [127.89, -3.39],
          [128.13, -2.84],
          [130.47, -3.09],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [153.1, -4.5],
          [152.82, -4.76],
          [152.40, -3.7],
          [150.66, -2.74],
          [152.2, -3.2],
          [153.1, -4.5],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [134.14, -1.15],
          [134.42, -2.76],
          [135.45, -3.36],
          [136.29, -2.30],
          [138.3, -1.70],
          [144.58, -3.86],
          [145.98, -5.46],
          [147.64, -6.08],
          [147.89, -6.61],
          [146.97, -6.72],
          [147.19, -7.38],
          [150.69, -10.58],
          [147.91, -10.1],
          [146.04, -8.06],
          [144.74, -7.6],
          [143.28, -8.24],
          [143.41, -8.98],
          [142.62, -9.32],
          [139.12, -8.09],
          [137.61, -8.41],
          [138.66, -7.3],
          [137.92, -5.39],
          [133.66, -3.53],
          [132.98, -4.11],
          [131.9, -2.82],
          [133.69, -2.21],
          [132.23, -2.21],
          [130.5, -0.93],
          [132.3, -0.3],
          [134.14, -1.15],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [125.24, 1.4],
          [123.68, 0.23],
          [120.18, 0.23],
          [120.04, -0.5],
          [120.93, -1.40],
          [123.34, -0.61],
          [121.50, -1.90],
          [123.16, -5.34],
          [122.23, -5.28],
          [122.7, -4.46],
          [121.48, -4.57],
          [120.97, -2.62],
          [120.30, -2.93],
          [120.43, -5.52],
          [119.36, -5.3],
          [119.49, -3.49],
          [118.76, -2.80],
          [120.03, 0.56],
          [120.88, 1.30],
          [122.92, 0.87],
          [125.24, 1.4],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [128.68, 1.13],
          [128.1, -0.9],
          [127.39, 1.01],
          [127.93, 2.17],
          [128.68, 1.13],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [105.81, -5.85],
          [104.7, -5.87],
          [102.58, -4.2],
          [99.26, 0.18],
          [98.60, 1.82],
          [95.29, 5.4],
          [97.48, 5.24],
          [100.64, 2.09],
          [101.65, 2.08],
          [103.83, 0.10],
          [103.43, -0.71],
          [106.10, -3.06],
          [105.81, -5.85],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [117.87, 1.82],
          [118.99, 0.90],
          [117.81, 0.78],
          [117.52, -0.80],
          [116.5, -1.48],
          [116.14, -4.01],
          [116.00, -3.65],
          [114.86, -4.10],
          [113.25, -3.11],
          [112.06, -3.47],
          [111.70, -2.99],
          [110.22, -2.93],
          [110.07, -1.59],
          [109.09, -0.4],
          [109.06, 1.34],
          [109.66, 2.00],
          [111.16, 1.85],
          [111.3, 2.69],
          [112.99, 3.10],
          [116.72, 6.92],
          [119.18, 5.40],
          [117.31, 3.23],
          [117.87, 1.82],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [126.37, 8.41],
          [126.53, 7.18],
          [126.19, 6.27],
          [125.83, 7.29],
          [125.36, 6.78],
          [125.39, 5.58],
          [124.2, 6.16],
          [124.24, 7.36],
          [123.6, 7.83],
          [121.9, 7.19],
          [123.48, 8.69],
          [123.84, 8.2],
          [125.47, 8.98],
          [125.41, 9.7],
          [126.22, 9.28],
          [126.37, 8.41],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [81.21, 6.19],
          [80.34, 5.96],
          [79.87, 6.76],
          [80.14, 9.82],
          [81.78, 7.52],
          [81.21, 6.19],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[-60.93, 10.1], [-61.9, 10.0], [-61.10, 10.8], [-60.93, 10.1]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [123.98, 10.27],
          [122.99, 9.02],
          [122.3, 9.71],
          [122.94, 10.88],
          [123.49, 10.94],
          [123.33, 10.26],
          [124.07, 11.23],
          [123.98, 10.27],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [118.50, 9.31],
          [117.17, 8.36],
          [119.51, 11.3],
          [119.6, 10.55],
          [118.50, 9.31],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [121.88, 11.89],
          [123.1, 11.58],
          [122.00, 10.44],
          [121.88, 11.89],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [125.50, 12.16],
          [125.78, 11.04],
          [125.01, 11.31],
          [125.27, 10.35],
          [124.80, 10.13],
          [124.30, 11.49],
          [124.87, 11.79],
          [124.26, 12.55],
          [125.50, 12.16],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [121.52, 13.0],
          [121.26, 12.20],
          [120.32, 13.46],
          [121.52, 13.0],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [121.32, 18.50],
          [122.24, 18.47],
          [122.51, 17.09],
          [121.66, 15.93],
          [121.72, 14.32],
          [123.9, 13.78],
          [124.07, 12.53],
          [122.92, 13.55],
          [122.67, 13.18],
          [122.03, 13.78],
          [120.62, 13.85],
          [120.99, 14.52],
          [120.0, 14.97],
          [119.88, 16.36],
          [120.28, 16.03],
          [120.71, 18.50],
          [121.32, 18.50],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-65.59, 18.22],
          [-67.18, 17.94],
          [-67.24, 18.37],
          [-65.59, 18.22],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-76.90, 17.86],
          [-78.33, 18.22],
          [-76.89, 18.40],
          [-76.2, 17.88],
          [-76.90, 17.86],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-72.5, 19.87],
          [-69.95, 19.64],
          [-68.31, 18.61],
          [-68.68, 18.20],
          [-70.66, 18.42],
          [-71.4, 17.59],
          [-72.37, 18.21],
          [-74.45, 18.34],
          [-72.33, 18.66],
          [-73.41, 19.6],
          [-72.5, 19.87],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [110.33, 18.67],
          [109.47, 18.19],
          [108.65, 18.50],
          [108.62, 19.36],
          [110.78, 20.07],
          [110.33, 18.67],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-155.54, 19.08],
          [-155.93, 19.05],
          [-155.86, 20.26],
          [-154.80, 19.50],
          [-155.54, 19.08],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-79.6, 22.76],
          [-74.29, 20.0],
          [-77.75, 19.85],
          [-77.08, 20.41],
          [-78.7, 21.59],
          [-81.82, 22.19],
          [-81.79, 22.63],
          [-84.97, 21.89],
          [-82.26, 23.18],
          [-79.6, 22.76],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-77.53, 23.7],
          [-78.40, 24.57],
          [-78.19, 25.2],
          [-77.53, 23.7],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [121.17, 22.79],
          [120.74, 21.97],
          [120.10, 23.55],
          [121.49, 25.29],
          [121.95, 24.99],
          [121.17, 22.79],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[-77, 26.5], [-77.17, 25.87], [-77.7, 27.0], [-77, 26.5]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [134.63, 34.14],
          [134.20, 33.20],
          [133.79, 33.52],
          [133.01, 32.70],
          [132.36, 32.98],
          [132.92, 34.0],
          [134.63, 34.14],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[34.57, 35.67], [32.9, 34.57], [32.25, 35.10], [34.57, 35.67]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [23.7, 35.70],
          [26.2, 35.3],
          [24.72, 34.9],
          [23.51, 35.2],
          [23.7, 35.70],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [15.5, 38.23],
          [15.1, 36.6],
          [12.43, 37.61],
          [12.57, 38.12],
          [15.5, 38.23],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [9.2, 41.2],
          [9.6, 39.17],
          [8.80, 38.90],
          [8.1, 40.9],
          [9.2, 41.2],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [140.97, 37.14],
          [140.25, 35.13],
          [137.21, 34.60],
          [135.79, 33.46],
          [135.07, 34.59],
          [130.98, 33.88],
          [132, 33.1],
          [131.33, 31.4],
          [130.68, 31.0],
          [130.20, 31.41],
          [130.44, 32.31],
          [129.40, 33.29],
          [132.61, 35.43],
          [135.67, 35.52],
          [136.72, 37.30],
          [137.39, 36.82],
          [139.42, 38.21],
          [139.88, 40.56],
          [141.36, 41.37],
          [141.88, 39.18],
          [140.97, 37.14],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [9.5, 42.15],
          [9.2, 41.3],
          [8.77, 41.58],
          [8.54, 42.25],
          [9.3, 43.0],
          [9.5, 42.15],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.9, 44.17],
          [145.32, 44.38],
          [145.54, 43.26],
          [144.0, 42.98],
          [143.18, 41.99],
          [141.61, 42.67],
          [141.06, 41.58],
          [139.95, 41.5],
          [139.81, 42.56],
          [140.31, 43.33],
          [141.38, 43.38],
          [141.96, 45.55],
          [143.9, 44.17],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-63.66, 46.5],
          [-62.01, 46.44],
          [-62.87, 45.96],
          [-64.14, 46.39],
          [-64.01, 47.03],
          [-63.66, 46.5],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-123.5, 48.5],
          [-125.65, 48.82],
          [-128.05, 49.99],
          [-128.35, 50.77],
          [-125.75, 50.29],
          [-123.5, 48.5],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-56.13, 50.68],
          [-56.79, 49.81],
          [-56.14, 50.1],
          [-55.82, 49.58],
          [-53.47, 49.24],
          [-53.78, 48.51],
          [-53.08, 48.68],
          [-52.64, 47.53],
          [-53.06, 46.65],
          [-54.17, 46.80],
          [-54.2, 47.75],
          [-55.40, 46.88],
          [-55.99, 46.9],
          [-55.29, 47.3],
          [-56.25, 47.63],
          [-59.26, 47.60],
          [-57.35, 50.71],
          [-55.40, 51.58],
          [-56.13, 50.68],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-132.7, 54.0],
          [-131.7, 54.1],
          [-132.04, 52.98],
          [-131.17, 52.1],
          [-133.05, 53.41],
          [-132.7, 54.0],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.64, 50.74],
          [144.65, 48.97],
          [143.17, 49.30],
          [142.55, 47.86],
          [143.50, 46.13],
          [142.74, 46.74],
          [142.09, 45.96],
          [141.59, 51.93],
          [142.65, 54.36],
          [143.64, 50.74],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-6.78, 52.2],
          [-9.97, 51.8],
          [-9.16, 52.86],
          [-9.68, 53.88],
          [-6.73, 55.17],
          [-5.66, 54.55],
          [-6.78, 52.2],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [12.6, 55.6],
          [12.0, 54.8],
          [10.90, 55.7],
          [12.37, 56.11],
          [12.6, 55.6],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-153.00, 57.11],
          [-154.00, 56.73],
          [-154.67, 57.46],
          [-152.56, 57.90],
          [-153.00, 57.11],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-3.00, 58.63],
          [-4.07, 57.55],
          [-1.95, 57.68],
          [-3.11, 55.97],
          [-2.08, 55.9],
          [0.4, 52.9],
          [1.68, 52.7],
          [1.4, 51.28],
          [0.5, 50.76],
          [-2.95, 50.69],
          [-5.24, 49.9],
          [-5.77, 50.1],
          [-3.41, 51.42],
          [-5.26, 51.99],
          [-4.22, 52.30],
          [-4.5, 53.49],
          [-3.09, 53.40],
          [-2.94, 53.98],
          [-4.84, 54.79],
          [-5.04, 55.78],
          [-5.58, 55.31],
          [-6.1, 56.78],
          [-5.0, 58.6],
          [-3.00, 58.63],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-79.26, 62.15],
          [-80.1, 61.71],
          [-79.92, 62.38],
          [-79.26, 62.15],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-81.89, 62.71],
          [-83.77, 62.18],
          [-83.2, 62.91],
          [-81.89, 62.71],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-171.73, 63.78],
          [-168.77, 63.18],
          [-171.55, 63.31],
          [-171.73, 63.78],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-85.16, 65.65],
          [-80.10, 63.72],
          [-80.99, 63.41],
          [-83.10, 64.10],
          [-85.52, 63.05],
          [-85.86, 63.63],
          [-87.22, 63.54],
          [-85.16, 65.65],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-14.50, 66.45],
          [-13.6, 65.12],
          [-14.9, 64.36],
          [-18.65, 63.49],
          [-22.76, 63.9],
          [-21.77, 64.40],
          [-23.95, 64.89],
          [-22.18, 65.08],
          [-24.32, 65.61],
          [-23.65, 66.26],
          [-22.13, 66.4],
          [-20.57, 65.73],
          [-14.50, 66.45],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-75.86, 67.14],
          [-77.23, 67.58],
          [-75.89, 68.28],
          [-75.86, 67.14],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-175.01, 66.58],
          [-174.3, 66.33],
          [-174.57, 67.06],
          [-171.85, 66.91],
          [-169.9, 65.97],
          [-172.5, 65.43],
          [-172.95, 64.25],
          [-178.3, 65.39],
          [-178.68, 66.11],
          [-180, 64.9],
          [-180, 68.96],
          [-174.92, 67.20],
          [-175.01, 66.58],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-95.64, 69.10],
          [-96.2, 68.75],
          [-99.79, 69.4],
          [-98.21, 70.14],
          [-95.64, 69.10],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[180, 70.83], [178.72, 71.09], [180, 71.51], [180, 70.83]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-178.69, 70.89],
          [-180, 70.83],
          [-180, 71.51],
          [-179.87, 71.55],
          [-177.57, 71.26],
          [-178.69, 70.89],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-90.54, 69.49],
          [-90.55, 68.47],
          [-89.21, 69.25],
          [-87.3, 67.19],
          [-85.52, 69.88],
          [-82.62, 69.65],
          [-81.2, 69.16],
          [-81.38, 67.11],
          [-83.34, 66.41],
          [-85.76, 66.55],
          [-87.32, 64.77],
          [-90.70, 63.6],
          [-94.24, 60.89],
          [-94.68, 58.94],
          [-93.21, 58.78],
          [-92.29, 57.08],
          [-90.89, 57.28],
          [-85.01, 55.30],
          [-82.27, 55.14],
          [-82.12, 53.27],
          [-79.91, 51.20],
          [-78.60, 52.56],
          [-79.8, 54.66],
          [-76.54, 56.53],
          [-78.51, 58.80],
          [-77.33, 59.85],
          [-78.10, 62.3],
          [-73.8, 62.44],
          [-71.37, 61.13],
          [-69.5, 61.06],
          [-69.28, 58.95],
          [-67.6, 58.21],
          [-64.58, 60.33],
          [-61.39, 56.96],
          [-61.79, 56.33],
          [-57.33, 54.62],
          [-55.75, 53.27],
          [-55.68, 52.14],
          [-60.03, 50.24],
          [-66.39, 50.22],
          [-71.10, 46.82],
          [-66.55, 49.13],
          [-65.05, 49.23],
          [-64.17, 48.74],
          [-65.11, 48.07],
          [-64.47, 46.23],
          [-61.52, 45.88],
          [-60.51, 47.00],
          [-59.80, 45.9],
          [-65.36, 43.54],
          [-66.12, 43.61],
          [-66.16, 44.46],
          [-64.42, 45.29],
          [-67.13, 45.13],
          [-70.11, 43.68],
          [-70.82, 42.33],
          [-69.96, 41.63],
          [-73.7, 40.93],
          [-71.94, 40.9],
          [-73.95, 40.75],
          [-74.90, 38.9],
          [-75.52, 39.49],
          [-75.05, 38.40],
          [-75.9, 37.21],
          [-76.3, 39.1],
          [-76.32, 38.08],
          [-76.9, 38.23],
          [-76.30, 37.91],
          [-75.72, 35.55],
          [-81.33, 31.4],
          [-80.05, 26.8],
          [-80.38, 25.20],
          [-81.7, 25.8],
          [-82.9, 29.1],
          [-84.1, 30.0],
          [-85.10, 29.63],
          [-86.4, 30.4],
          [-89.1, 30.31],
          [-89.40, 29.1],
          [-93.22, 29.78],
          [-94.6, 29.4],
          [-97.1, 27.8],
          [-97.70, 24.27],
          [-97.69, 21.89],
          [-95.90, 18.82],
          [-94.42, 18.14],
          [-91.40, 18.87],
          [-90.77, 19.28],
          [-90.27, 21],
          [-87.05, 21.54],
          [-86.84, 20.8],
          [-87.83, 18.2],
          [-88.3, 18.5],
          [-88.35, 16.53],
          [-88.93, 15.88],
          [-84.98, 15.99],
          [-83.4, 15.27],
          [-83.80, 11.10],
          [-82.20, 8.99],
          [-81.43, 8.78],
          [-79.57, 9.61],
          [-76.83, 8.63],
          [-75.67, 9.44],
          [-74.90, 11.08],
          [-73.41, 11.22],
          [-71.75, 12.43],
          [-71.13, 12.11],
          [-71.94, 11.42],
          [-71.69, 9.07],
          [-71.0, 9.8],
          [-71.40, 10.96],
          [-70.15, 11.37],
          [-69.94, 12.16],
          [-68.19, 10.55],
          [-66.22, 10.64],
          [-64.8, 10.07],
          [-64.31, 10.64],
          [-61.88, 10.71],
          [-62.7, 10.4],
          [-62.38, 9.94],
          [-60.83, 9.38],
          [-60.67, 8.5],
          [-59.10, 7.99],
          [-57.14, 5.97],
          [-53.95, 5.75],
          [-51.31, 4.20],
          [-50.50, 1.90],
          [-49.97, 1.73],
          [-50.69, 0.22],
          [-48.6, -0.23],
          [-48.58, -1.23],
          [-47.82, -0.58],
          [-44.90, -1.55],
          [-44.58, -2.69],
          [-43.41, -2.38],
          [-39.97, -2.87],
          [-37.22, -4.82],
          [-35.23, -5.46],
          [-34.7, -7.34],
          [-35.12, -8.99],
          [-38.67, -13.05],
          [-39.26, -17.86],
          [-40.94, -21.93],
          [-41.98, -22.9],
          [-44.64, -23.35],
          [-47.64, -24.88],
          [-48.49, -25.87],
          [-48.88, -28.67],
          [-53.80, -34.39],
          [-56.21, -34.8],
          [-58.42, -33.90],
          [-56.73, -36.41],
          [-57.74, -38.18],
          [-62.33, -38.82],
          [-62.14, -40.67],
          [-65.11, -41.06],
          [-64.97, -42.05],
          [-63.75, -42.04],
          [-63.45, -42.56],
          [-65.18, -43.49],
          [-65.56, -45.03],
          [-67.29, -45.55],
          [-67.58, -46.30],
          [-65.64, -47.23],
          [-69.13, -50.73],
          [-68.1, -52.3],
          [-70.84, -52.89],
          [-71.00, -53.83],
          [-74.94, -52.26],
          [-75.60, -48.67],
          [-74.12, -46.93],
          [-75.64, -46.64],
          [-74.35, -44.10],
          [-73.2, -44.45],
          [-72.71, -42.38],
          [-73.38, -42.11],
          [-73.70, -43.36],
          [-74.33, -43.22],
          [-73.21, -39.25],
          [-73.58, -37.15],
          [-71.43, -32.41],
          [-71.4, -28.86],
          [-70.90, -27.6],
          [-70.16, -19.75],
          [-70.37, -18.34],
          [-71.46, -17.36],
          [-76.00, -14.64],
          [-79.03, -8.38],
          [-81.2, -6.13],
          [-80.92, -5.6],
          [-81.41, -4.73],
          [-79.7, -2.65],
          [-80.96, -2.24],
          [-80.93, -1.05],
          [-80.09, 0.76],
          [-78.85, 1.38],
          [-78.42, 2.6],
          [-77.12, 3.8],
          [-78.18, 8.31],
          [-79.55, 8.93],
          [-80.48, 8.0],
          [-80.00, 7.54],
          [-80.88, 7.22],
          [-81.72, 8.10],
          [-82.85, 8.07],
          [-84.97, 10.08],
          [-85.11, 9.55],
          [-85.66, 9.93],
          [-85.71, 11.08],
          [-87.66, 12.9],
          [-87.48, 13.29],
          [-91.23, 13.92],
          [-94.69, 16.20],
          [-96.55, 15.65],
          [-103.50, 18.29],
          [-105.49, 19.94],
          [-105.26, 21.42],
          [-106.02, 22.77],
          [-109.2, 25.58],
          [-109.29, 26.44],
          [-112.22, 28.95],
          [-113.14, 31.17],
          [-114.77, 31.8],
          [-114.67, 30.16],
          [-109.43, 23.18],
          [-110.03, 22.82],
          [-112.18, 24.73],
          [-112.30, 26.01],
          [-115.05, 27.72],
          [-114.16, 28.56],
          [-115.51, 29.55],
          [-117.29, 33.04],
          [-120.62, 34.60],
          [-123.72, 38.95],
          [-124.39, 40.31],
          [-123.89, 45.52],
          [-124.68, 48.18],
          [-123.1, 48.0],
          [-122.58, 47.09],
          [-122.5, 48.1],
          [-122.8, 49],
          [-127.43, 50.83],
          [-127.8, 52.3],
          [-129.1, 52.75],
          [-131.96, 55.49],
          [-134.07, 58.12],
          [-137.8, 58.5],
          [-139.86, 59.53],
          [-147.11, 60.88],
          [-148.22, 60.67],
          [-148.01, 59.97],
          [-151.71, 59.15],
          [-150.62, 61.28],
          [-154.01, 59.3],
          [-153.28, 58.86],
          [-154.23, 58.14],
          [-158.43, 55.99],
          [-164.78, 54.40],
          [-158.68, 57.01],
          [-157.04, 58.91],
          [-159.05, 58.42],
          [-160.35, 59.07],
          [-161.96, 58.67],
          [-161.87, 59.63],
          [-165.34, 60.50],
          [-166.12, 61.5],
          [-164.56, 63.14],
          [-160.77, 63.76],
          [-160.77, 64.78],
          [-164.96, 64.44],
          [-168.1, 65.6],
          [-164.47, 66.57],
          [-163.78, 66.07],
          [-161.67, 66.11],
          [-166.76, 68.35],
          [-166.20, 68.88],
          [-164.43, 68.91],
          [-161.90, 70.33],
          [-156.58, 71.35],
          [-154.34, 70.69],
          [-136.50, 68.89],
          [-129.79, 70.19],
          [-129.10, 69.77],
          [-128.13, 70.48],
          [-125.75, 69.48],
          [-124.42, 70.15],
          [-124.2, 69.4],
          [-122.68, 69.85],
          [-115.24, 68.90],
          [-113.89, 68.39],
          [-115.30, 67.90],
          [-113.49, 67.68],
          [-109.94, 67.98],
          [-108.8, 67.38],
          [-108.16, 68.65],
          [-106.1, 68.8],
          [-101.45, 67.64],
          [-98.44, 67.78],
          [-97.66, 68.57],
          [-96.1, 68.2],
          [-96.12, 67.29],
          [-94.23, 69.06],
          [-96.47, 70.0],
          [-95.20, 71.9],
          [-91.5, 70.19],
          [-92.40, 69.7],
          [-90.54, 69.49],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-114.16, 73.12],
          [-114.66, 72.65],
          [-112.44, 72.95],
          [-111.0, 72.4],
          [-109.9, 72.96],
          [-108.18, 71.65],
          [-108.39, 73.0],
          [-105.40, 72.67],
          [-104.46, 70.99],
          [-100.98, 70.02],
          [-102.73, 69.50],
          [-102.4, 68.75],
          [-105.9, 69.1],
          [-113.31, 68.53],
          [-116.10, 69.16],
          [-117.3, 69.9],
          [-112.41, 70.36],
          [-117.90, 70.54],
          [-118.43, 70.90],
          [-116.11, 71.30],
          [-119.40, 71.55],
          [-117.86, 72.70],
          [-114.16, 73.12],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[-104.5, 73.4], [-105.3, 72.7], [-106.9, 73.4], [-104.5, 73.4]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-76.3, 73.10],
          [-79.48, 72.74],
          [-80.83, 73.69],
          [-76.3, 73.10],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-86.56, 73.15],
          [-85.77, 72.53],
          [-82.31, 73.75],
          [-80.74, 72.06],
          [-77.82, 72.7],
          [-74.09, 71.33],
          [-72.24, 71.55],
          [-67.91, 70.12],
          [-66.96, 69.18],
          [-68.80, 68.7],
          [-61.85, 66.86],
          [-63.91, 64.99],
          [-66.72, 66.38],
          [-68.01, 66.26],
          [-64.66, 63.39],
          [-65.01, 62.67],
          [-68.78, 63.74],
          [-66.16, 61.93],
          [-71.02, 62.91],
          [-74.83, 64.67],
          [-77.7, 64.2],
          [-78.55, 64.57],
          [-77.89, 65.30],
          [-73.9, 65.45],
          [-72.65, 67.28],
          [-78.95, 70.16],
          [-81.30, 69.74],
          [-88.68, 70.41],
          [-90.20, 72.23],
          [-88.40, 73.53],
          [-85.82, 73.80],
          [-86.56, 73.15],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-100.35, 73.84],
          [-97.1, 73.4],
          [-96.7, 71.6],
          [-98.3, 71.27],
          [-102.5, 72.5],
          [-100.43, 72.70],
          [-100.35, 73.84],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.60, 73.21],
          [139.86, 73.3],
          [142.06, 73.85],
          [143.60, 73.21],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-93.19, 72.77],
          [-95.4, 72.06],
          [-94.50, 74.13],
          [-90.5, 73.85],
          [-93.19, 72.77],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-120.4, 71.4],
          [-123.09, 70.90],
          [-125.92, 71.86],
          [-124.91, 74.29],
          [-117.55, 74.18],
          [-115.51, 73.47],
          [-120.4, 71.4],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [150.73, 75.08],
          [149.57, 74.68],
          [146.11, 75.17],
          [150.73, 75.08],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-93.61, 74.9],
          [-94.15, 74.59],
          [-96.82, 74.92],
          [-94.85, 75.64],
          [-93.61, 74.9],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [145.08, 75.56],
          [144.3, 74.8],
          [138.95, 74.61],
          [136.97, 75.26],
          [138.83, 76.13],
          [145.08, 75.56],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-98.5, 76.7],
          [-98.1, 75],
          [-99.80, 74.89],
          [-102.56, 76.33],
          [-98.5, 76.7],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-108.21, 76.20],
          [-105.88, 75.96],
          [-106.31, 75.00],
          [-112.22, 74.41],
          [-113.87, 74.7],
          [-111.79, 75.16],
          [-117.7, 75.22],
          [-115.40, 76.47],
          [-110.81, 75.54],
          [-109.06, 75.47],
          [-109.58, 76.79],
          [-108.21, 76.20],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [57.53, 70.7],
          [53.67, 70.76],
          [51.45, 72.01],
          [55.63, 75.08],
          [68.15, 76.9],
          [68.18, 76.23],
          [58.47, 74.30],
          [55.41, 72.37],
          [57.53, 70.7],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-94.68, 77.09],
          [-89.18, 75.6],
          [-81.12, 75.71],
          [-80.45, 74.65],
          [-88.1, 74.39],
          [-92.42, 74.83],
          [-93.89, 76.31],
          [-97.12, 76.75],
          [-94.68, 77.09],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-116.19, 77.64],
          [-117.10, 76.5],
          [-122.85, 76.11],
          [-116.19, 77.64],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [106.9, 76.97],
          [107.2, 76.4],
          [111.07, 76.7],
          [114.13, 75.84],
          [109.4, 74.1],
          [113.01, 73.97],
          [113.5, 73.33],
          [115.56, 73.75],
          [123.20, 72.97],
          [123.25, 73.73],
          [126.97, 73.56],
          [131.28, 70.78],
          [132.25, 71.83],
          [133.85, 71.38],
          [139.8, 71.48],
          [140.46, 72.84],
          [149.5, 72.2],
          [152.96, 70.84],
          [158.99, 70.86],
          [160.94, 69.43],
          [167.83, 69.58],
          [169.57, 68.69],
          [170.81, 69.01],
          [170.45, 70.09],
          [178.6, 69.4],
          [180, 68.96],
          [180, 64.9],
          [177.41, 64.60],
          [179.22, 62.30],
          [177.36, 62.52],
          [173.6, 61.65],
          [170.33, 59.88],
          [168.90, 60.57],
          [166.29, 59.78],
          [163.53, 59.86],
          [162.01, 58.24],
          [163.19, 57.61],
          [162.11, 54.85],
          [160.36, 54.34],
          [160.02, 53.20],
          [158.53, 52.95],
          [156.7, 51.01],
          [155.43, 55.38],
          [155.91, 56.76],
          [163.6, 61.14],
          [164.47, 62.55],
          [160.12, 60.54],
          [159.30, 61.77],
          [156.72, 61.43],
          [154.21, 59.75],
          [155.04, 59.14],
          [151.26, 58.78],
          [151.33, 59.50],
          [149.78, 59.65],
          [148.54, 59.16],
          [142.19, 59.0],
          [135.12, 54.7],
          [138.16, 53.75],
          [139.90, 54.1],
          [141.34, 53.0],
          [140.06, 48.44],
          [134.8, 43.39],
          [133.53, 42.81],
          [132.27, 43.28],
          [129.96, 41.94],
          [129.70, 40.88],
          [127.53, 39.75],
          [129.46, 36.78],
          [129.09, 35.08],
          [126.48, 34.3],
          [126.11, 36.72],
          [126.8, 36.89],
          [126.17, 37.7],
          [124.71, 38.10],
          [125.32, 39.55],
          [124.26, 39.92],
          [121.05, 38.89],
          [122.16, 40.42],
          [121.64, 40.94],
          [117.53, 38.73],
          [119.70, 37.15],
          [120.82, 37.8],
          [122.5, 36.93],
          [121.10, 36.65],
          [119.15, 34.9],
          [120.22, 34.3],
          [121.90, 31.69],
          [121.26, 30.67],
          [122.09, 29.83],
          [121.68, 28.22],
          [118.65, 24.54],
          [115.89, 22.78],
          [110.78, 21.39],
          [110.44, 20.34],
          [109.8, 20.28],
          [109.86, 21.39],
          [108.52, 21.71],
          [105.88, 19.75],
          [105.66, 19.05],
          [108.87, 15.27],
          [109.2, 11.66],
          [105.15, 8.6],
          [105.07, 9.91],
          [103.49, 10.63],
          [102.58, 12.18],
          [100.83, 12.62],
          [100.97, 13.41],
          [100.09, 13.40],
          [99.22, 9.23],
          [99.87, 9.20],
          [101.01, 6.85],
          [102.96, 5.52],
          [104.22, 1.29],
          [103.5, 1.22],
          [101.39, 2.76],
          [100.08, 6.46],
          [98.50, 8.38],
          [98.3, 7.79],
          [98.76, 11.44],
          [97.59, 16.10],
          [97.16, 16.92],
          [95.36, 15.71],
          [94.18, 16.03],
          [94.32, 18.21],
          [91.41, 22.76],
          [90.49, 22.80],
          [90.27, 21.83],
          [86.97, 21.49],
          [86.49, 20.15],
          [85.0, 19.47],
          [82.19, 16.55],
          [80.32, 15.89],
          [79.85, 10.35],
          [77.5, 7.96],
          [76.59, 8.89],
          [73.53, 15.99],
          [72.63, 21.35],
          [70.47, 20.87],
          [69.16, 22.08],
          [69.3, 22.84],
          [67.44, 23.94],
          [66.37, 25.42],
          [61.49, 25.07],
          [57.39, 25.7],
          [56.49, 27.14],
          [54.71, 26.48],
          [53.49, 26.81],
          [51.52, 27.86],
          [50.11, 30.14],
          [48.94, 30.31],
          [47.97, 29.97],
          [48.80, 27.6],
          [50.15, 26.6],
          [50.8, 24.75],
          [51.01, 26.00],
          [51.58, 25.80],
          [51.79, 24.0],
          [54.00, 24.12],
          [56.36, 26.39],
          [56.84, 24.24],
          [58.72, 23.56],
          [59.80, 22.3],
          [57.82, 20.24],
          [57.69, 18.94],
          [54.79, 16.95],
          [52.38, 16.38],
          [52.16, 15.59],
          [48.67, 14.00],
          [43.48, 12.63],
          [42.6, 16.77],
          [39.1, 21.29],
          [38.49, 23.68],
          [37.48, 24.28],
          [35.1, 28.06],
          [34.63, 28.05],
          [34.92, 29.50],
          [33.92, 27.64],
          [32.42, 29.85],
          [35.69, 23.92],
          [35.52, 23.10],
          [36.86, 22],
          [37.48, 18.61],
          [38.4, 17.99],
          [39.26, 15.92],
          [43.31, 12.3],
          [42.71, 11.73],
          [44.61, 10.44],
          [51.11, 12.02],
          [51.04, 10.64],
          [49.45, 6.80],
          [47.74, 4.21],
          [40.26, -2.57],
          [39.20, -4.67],
          [38.7, -5.90],
          [39.4, -6.8],
          [39.18, -8.48],
          [40.47, -10.76],
          [40.77, -14.69],
          [40.08, -16.10],
          [34.78, -19.78],
          [35.56, -22.0],
          [35.45, -24.12],
          [32.57, -25.72],
          [32.46, -28.30],
          [30.05, -31.1],
          [25.78, -33.94],
          [22.57, -33.86],
          [19.61, -34.81],
          [18.37, -34.13],
          [18.22, -31.66],
          [15.21, -27.09],
          [14.25, -22.11],
          [11.79, -18.06],
          [11.77, -15.79],
          [13.63, -12.03],
          [13.68, -10.73],
          [11.91, -5.03],
          [8.79, -1.11],
          [9.79, 3.07],
          [8.5, 4.77],
          [5.89, 4.26],
          [4.32, 6.27],
          [1.86, 6.14],
          [-1.96, 4.71],
          [-4.6, 5.16],
          [-7.51, 4.33],
          [-9.00, 4.83],
          [-12.42, 7.26],
          [-14.83, 10.87],
          [-16.61, 12.17],
          [-16.71, 13.59],
          [-17.62, 14.7],
          [-16.46, 16.13],
          [-16.14, 18.10],
          [-16.27, 20.09],
          [-17.06, 21],
          [-14.4, 26.25],
          [-9.56, 29.93],
          [-9.30, 32.56],
          [-6.91, 34.1],
          [-5.9, 35.7],
          [-2.1, 35.16],
          [1.46, 36.60],
          [9.5, 37.3],
          [10.18, 36.72],
          [11.02, 37.09],
          [10.3, 33.78],
          [19.08, 30.26],
          [20.05, 30.98],
          [20.13, 32.23],
          [21.54, 32.84],
          [25.16, 31.56],
          [28.91, 30.8],
          [30.97, 31.55],
          [31.96, 30.93],
          [34.26, 31.21],
          [35.99, 34.64],
          [36.16, 36.65],
          [32.50, 36.10],
          [31.7, 36.64],
          [29.7, 36.14],
          [27.64, 36.65],
          [26.31, 38.20],
          [26.80, 38.98],
          [26.17, 39.46],
          [27.2, 40.4],
          [28.8, 40.4],
          [29.2, 41.2],
          [31.14, 41.08],
          [33.51, 42.01],
          [38.34, 40.94],
          [41.55, 41.53],
          [41.45, 42.64],
          [36.67, 45.24],
          [39.12, 47.26],
          [34.96, 46.27],
          [35.02, 45.65],
          [36.5, 45.4],
          [36.33, 45.11],
          [33.88, 44.36],
          [32.45, 45.32],
          [33.29, 46.08],
          [30.74, 46.58],
          [29.62, 45.03],
          [28.83, 44.91],
          [27.67, 42.57],
          [28.80, 41.05],
          [26.35, 40.15],
          [26.05, 40.82],
          [24.92, 40.94],
          [23.71, 40.68],
          [24.40, 40.12],
          [23.9, 39.96],
          [22.62, 40.25],
          [22.97, 38.97],
          [24.02, 38.2],
          [24.0, 37.65],
          [23.11, 37.9],
          [23.4, 37.4],
          [22.77, 37.30],
          [23.15, 36.42],
          [21.6, 36.84],
          [19.40, 40.25],
          [19.5, 41.7],
          [16.01, 43.50],
          [14.90, 45.07],
          [13.95, 44.80],
          [13.93, 45.59],
          [13.14, 45.73],
          [12.32, 45.38],
          [12.58, 44.09],
          [15.14, 41.95],
          [18.4, 40.16],
          [18.29, 39.81],
          [16.8, 40.44],
          [16.44, 39.79],
          [17.05, 38.90],
          [16.10, 37.98],
          [15.41, 40.04],
          [12.10, 41.70],
          [10.2, 43.9],
          [8.88, 44.36],
          [6.52, 43.12],
          [3.10, 43.07],
          [3.03, 41.89],
          [0.8, 41.01],
          [-0.27, 39.3],
          [0.11, 38.73],
          [-2.14, 36.67],
          [-4.36, 36.67],
          [-5.37, 35.94],
          [-6.5, 36.94],
          [-8.89, 36.86],
          [-8.8, 38.26],
          [-9.52, 38.73],
          [-8.76, 40.76],
          [-9.39, 43.02],
          [-7.97, 43.74],
          [-1.90, 43.42],
          [-1.19, 46.01],
          [-2.96, 47.5],
          [-4.49, 47.95],
          [-4.59, 48.68],
          [-1.61, 48.64],
          [-1.93, 49.77],
          [-0.98, 49.34],
          [1.33, 50.12],
          [1.63, 50.94],
          [3.8, 51.6],
          [4.70, 53.09],
          [8.12, 53.52],
          [8.80, 54.02],
          [8.54, 57.1],
          [10.5, 57.7],
          [10.91, 56.45],
          [9.6, 55.4],
          [10.9, 54.00],
          [12.51, 54.47],
          [14.1, 53.75],
          [17.62, 54.85],
          [19.66, 54.42],
          [21.26, 55.1],
          [21.58, 57.41],
          [22.52, 57.75],
          [24.12, 57.02],
          [24.42, 58.38],
          [23.3, 59.18],
          [27.98, 59.47],
          [29.11, 60.02],
          [28.0, 60.50],
          [22.8, 59.84],
          [21.32, 60.7],
          [21.53, 63.1],
          [25.39, 65.11],
          [23.90, 66.00],
          [17.84, 62.7],
          [17.1, 61.34],
          [18.78, 60.08],
          [16.82, 58.7],
          [15.8, 56.10],
          [14.66, 56.20],
          [14.10, 55.40],
          [12.94, 55.36],
          [10.35, 59.4],
          [8.38, 58.31],
          [7.04, 58.07],
          [5.66, 58.58],
          [4.99, 61.97],
          [10.52, 64.48],
          [19.18, 69.81],
          [28.16, 71.18],
          [31.29, 70.45],
          [30.00, 70.18],
          [31.10, 69.55],
          [32.13, 69.90],
          [40.29, 67.93],
          [41.12, 66.79],
          [40.01, 66.26],
          [38.38, 66],
          [33.18, 66.63],
          [34.81, 65.9],
          [34.94, 64.41],
          [37.01, 63.8],
          [37.17, 65.14],
          [39.59, 64.52],
          [39.76, 65.49],
          [42.09, 66.47],
          [43.9, 66.06],
          [43.45, 68.57],
          [46.2, 68.2],
          [46.34, 66.66],
          [53.71, 68.85],
          [53.48, 68.20],
          [54.72, 68.09],
          [58.80, 68.88],
          [59.94, 68.27],
          [60.5, 69.8],
          [68.51, 68.09],
          [66.69, 71.02],
          [69.9, 73.0],
          [72.79, 72.2],
          [71.84, 71.40],
          [73.66, 68.40],
          [71.2, 66.3],
          [72.42, 66.17],
          [75.05, 67.7],
          [73.10, 71.44],
          [74.65, 72.83],
          [76.35, 71.15],
          [75.90, 71.87],
          [77.57, 72.26],
          [81.5, 71.7],
          [80.51, 73.64],
          [86.82, 73.93],
          [87.16, 75.11],
          [100.7, 76.4],
          [104.35, 77.69],
          [106.9, 76.97],
        ],
        [
          [49.1, 41.28],
          [50.39, 40.25],
          [49.56, 40.17],
          [48.85, 38.81],
          [49.2, 37.58],
          [50.84, 36.87],
          [53.82, 36.96],
          [53.88, 38.95],
          [52.69, 40.03],
          [52.91, 40.87],
          [54.73, 40.95],
          [53.72, 42.12],
          [52.81, 41.13],
          [52.50, 42.79],
          [50.33, 44.28],
          [51.27, 44.51],
          [51.31, 45.24],
          [53.04, 45.25],
          [53.04, 46.85],
          [51.19, 47.04],
          [49.10, 46.39],
          [46.68, 44.60],
          [49.1, 41.28],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-110.18, 77.69],
          [-113.53, 77.73],
          [-111.26, 78.15],
          [-110.18, 77.69],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [24.72, 77.85],
          [22.4, 77.44],
          [20.81, 78.25],
          [22.88, 78.45],
          [24.72, 77.85],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-95.8, 78.05],
          [-98.12, 78.08],
          [-98.63, 78.87],
          [-95.8, 78.05],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-100.0, 78.32],
          [-99.67, 77.90],
          [-105.17, 78.3],
          [-105.49, 79.30],
          [-100.0, 78.32],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [105.07, 78.30],
          [99.43, 77.92],
          [102.08, 79.34],
          [105.07, 78.30],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [18.25, 79.70],
          [21.54, 78.95],
          [15.91, 76.7],
          [10.44, 79.65],
          [18.25, 79.70],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [25.44, 80.40],
          [27.40, 80.05],
          [23.02, 79.4],
          [17.36, 80.31],
          [25.44, 80.40],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [51.13, 80.54],
          [47.58, 80.0],
          [44.84, 80.5],
          [50.0, 80.91],
          [51.13, 80.54],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [99.9, 78.88],
          [94.97, 79.04],
          [91.18, 80.34],
          [95.94, 81.2],
          [99.9, 78.88],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-87.0, 79.6],
          [-89.03, 78.28],
          [-92.87, 78.34],
          [-96.7, 80.15],
          [-94.73, 81.20],
          [-87.0, 79.6],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-68.5, 83.10],
          [-61.89, 82.36],
          [-71.1, 79.8],
          [-76.90, 79.32],
          [-75.39, 78.52],
          [-79.7, 77.2],
          [-77.88, 76.77],
          [-80.56, 76.17],
          [-89.49, 76.47],
          [-88.2, 77.9],
          [-84.97, 77.53],
          [-87.96, 78.37],
          [-85.09, 79.34],
          [-86.93, 80.25],
          [-81.84, 80.46],
          [-87.59, 80.51],
          [-91.58, 81.89],
          [-85.5, 82.65],
          [-83.1, 82.3],
          [-79.30, 83.13],
          [-68.5, 83.10],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-27.1, 83.5],
          [-20.84, 82.72],
          [-31.39, 82.02],
          [-22.90, 82.09],
          [-23.1, 81.15],
          [-15.76, 81.91],
          [-12.20, 81.29],
          [-20.04, 80.17],
          [-17.7, 80.12],
          [-18.47, 76.98],
          [-21.67, 76.62],
          [-19.37, 74.29],
          [-21.59, 74.22],
          [-20.76, 73.46],
          [-23.56, 73.30],
          [-22.3, 72.18],
          [-24.79, 72.3],
          [-21.75, 70.66],
          [-23.53, 70.47],
          [-25.54, 71.43],
          [-26.36, 70.22],
          [-22.34, 70.12],
          [-27.74, 68.4],
          [-31.77, 68.12],
          [-34.20, 66.6],
          [-39.81, 65.45],
          [-42.81, 62.68],
          [-43.37, 60.09],
          [-44.78, 60.03],
          [-46.26, 60.85],
          [-48.26, 60.85],
          [-51.63, 63.62],
          [-53.96, 67.18],
          [-50.87, 69.92],
          [-53.45, 69.28],
          [-54.68, 69.6],
          [-54.35, 70.82],
          [-51.3, 70.5],
          [-55.83, 71.65],
          [-54.71, 72.58],
          [-58.58, 75.51],
          [-61.26, 76.10],
          [-68.50, 76.06],
          [-71.40, 77.00],
          [-66.76, 77.37],
          [-73.29, 78.04],
          [-65.71, 79.39],
          [-68.02, 80.11],
          [-62.65, 81.7],
          [-53.04, 81.88],
          [-50.39, 82.43],
          [-44.52, 81.66],
          [-46.76, 82.62],
          [-43.40, 83.22],
          [-27.1, 83.5],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [3.2, 39.75],
          [3.39, 39.77],
          [3.46, 39.69],
          [3.34, 39.55],
          [3.24, 39.38],
          [3.07, 39.30],
          [2.8, 39.38],
          [2.7, 39.5],
          [2.6, 39.55],
          [2.5, 39.47],
          [2.39, 39.5],
          [2.37, 39.61],
          [2.90, 39.90],
          [3.19, 39.9],
          [3.16, 39.90],
          [3.19, 39.86],
          [3.14, 39.7],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [4.27, 39.8],
          [3.8, 39.9],
          [3.84, 40.03],
          [4.05, 40.07],
          [4.31, 39.91],
          [4.29, 39.84],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [1.59, 38.67],
          [1.50, 38.6],
          [1.40, 38.71],
          [1.43, 38.76],
          [1.49, 38.71],
          [1.59, 38.67],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [1.44, 38.91],
          [1.25, 38.87],
          [1.25, 38.97],
          [1.30, 39.03],
          [1.56, 39.12],
          [1.62, 39.03],
          [1.44, 38.91],
        ],
      ],
    },
  },
];
export default data;
